import {
  getDifference,
  getUnion,
  isPointInsideContour,
} from './contourHandling';

interface NudgeCircle2D {
  center: [number, number];
  radius: number;
}

export function nudgePoints2D(
  data: [number, number][],
  nudgeCircle: NudgeCircle2D,
) {
  const { center, radius } = nudgeCircle;
  const polyline = data.slice();

  // Calculate the number of points for the circlePolyline
  const numPoints = Math.ceil(2 * Math.PI * radius * 4); // Multiply by 4 for the subpixel grid

  // Generate the points around the edge of the circle
  const circlePolyline = Array.from({ length: numPoints }, (_, i) => {
    const angle = (i / numPoints) * 2 * Math.PI; // Calculate the angle for this point
    const x = center[0] + (radius * 4 * Math.cos(angle)) / 4; // Calculate the x-coordinate
    const y = center[1] + (radius * 4 * Math.sin(angle)) / 4; // Calculate the y-coordinate
    return [x, y] as [number, number];
  });

  // Determine if the tool is coming from the inside or the outside
  const isInside = isPointInsideContour(center, polyline);

  // Return the difference or the union of the polylines, depending on whether the tool is coming from the inside or the outside
  return isInside
    ? getUnion(polyline, circlePolyline)
    : getDifference(polyline, circlePolyline);
}
